export default __webpack_public_path__ + "static/media/trash.f0bd97a3.svg";